import JEDescription from "./description";
export default JEDescription;
